import { ROUTES } from 'services/utils/enums';
import { sendRequest } from 'services/api';

const getEstimate = async (params) => {
    return sendRequest(ROUTES.GET_ESTIMATE, '', params.data);
};

export default {
    getEstimate,
};
